import React, { useContext } from 'react'
import { View, Text, Image, StyleSheet } from 'react-native'
import { useAppSelector } from './store'
import { extra, MAX_CONTENT_WIDTH } from './config'
import { ShadowView, textStyles } from './style'
import { ThemeContext } from './utility/context/ThemeContext'
import { AntDesign } from '@expo/vector-icons'
import ExternalLink from './utility/external-link'
import { logoUrl, Promotion as PromotionType } from '@ecountabl/lib'
import VisibilitySensor from './utility/visibility-sensor'
import impressionAggregator from './utility/impression-aggregator'
import Analytics from './utility/analytics'
import Loader from './utility/loader'
import Typewriter from './utility/typewriter'

const Promotion: React.FC = () => {
  const { theme } = useContext(ThemeContext)
  const { textMain, bgMain, bgSecond } = theme.colors
  const { user: { customer } } = useAppSelector(state => state.auth)
  const promotion = customer?.promotion as PromotionType | null | undefined

  const { syncStatus} = useAppSelector(state => state.auth)

  if (syncStatus === 'loading') {
    return (
      <View style={{alignSelf: "center", width: "100%", maxWidth: MAX_CONTENT_WIDTH, gap: 10, paddingHorizontal: 16, justifyContent: "center", alignItems: "center"}}>
        <Loader />
        <Text style={[textStyles.body, {color: textMain}]}>
          Loading<Typewriter text="..." restartDelay={500} style={textStyles.body}/>
        </Text>
      </View>
    )
  }

  if (!promotion) return null

  const { sectionTitle, promotionText, items } = promotion

  return (
    <View style={{alignSelf: "center", width: "100%", maxWidth: MAX_CONTENT_WIDTH, gap: 10, paddingHorizontal: 16}}>
      <Text
        style={[textStyles.h2, {color: textMain}]}
      >
       {sectionTitle}
      </Text>
      <ShadowView style={[styles.card, {backgroundColor: bgMain}]}>
        <Text style={[textStyles.body, {color: textMain}]}>
          {promotionText}
        </Text>
        <View style={{marginTop: 16}}>
        {(items || [])
          .filter(item => item && item.name && item.url)
          .map((item, index) => (
          <VisibilitySensor key={index} onChange={(visible) => {
            if (visible) {
              impressionAggregator.promotion.add({
                name: item.name as string,
                index: index,
                url: item.url as string,
                customerId: customer?._id as string,
              })
            }
          }}>
            <ExternalLink
              key={index}
              href={item.url as string}
              onPress={() => {
                Analytics.track('promotion_click', {
                  index: index,
                  promotionName: item.name,
                  promotionUrl: item.url,
                  customerId: customer?._id as string,
                })
              }}
            >
              <View
                key={index}
                style={{flexDirection: "row", alignItems: "center", gap: 16, padding: 8}}
                onMouseEnter={(e) => {
                  if (e.currentTarget && e.currentTarget.style) {
                    e.currentTarget.style.background = bgSecond
                  }
                }}
                onMouseLeave={(e) => {
                  if (e.currentTarget && e.currentTarget.style) {
                    e.currentTarget.style.background = ""
                  }
                }}
              >
                {item.image ? (
                  <Image source={{ uri: logoUrl(item.image, extra.cdn) }} style={{ width: 50, height: 50, resizeMode: "contain" }} />
                ) : null}
                <View style={{flex: 1, flexDirection: "column", gap: 4}}>
                  <Text style={[textStyles.h4, {color: textMain}]}>{item.name as string}</Text>
                  {item.description ? (
                    <Text style={[textStyles.label, {color: textMain}]}>{item.description}</Text>
                  ) : null}
                </View>
                <AntDesign name="right" size={24} color={textMain} />
              </View>
            </ExternalLink>
          </VisibilitySensor>
        ))}
        </View>
      </ShadowView>
    </View>
  )
}

export default Promotion

const styles = StyleSheet.create({
  card: {
    borderRadius: 10,
    padding: 16
  },
  featuredCard: {
    height: "100%",
    width: 250,
    borderRadius: 8,
  },
  errorCard: {
    marginHorizontal: 16,
    padding: 16,
    borderRadius: 10,
    flexDirection: "row",
  },
  featuredTextContainer: {
    width: "100%",
    paddingTop: 12,
    paddingBottom: 20,
    paddingHorizontal: 16,
    flexDirection: "column",
    justifyContent: "space-between",
    gap: 5
  }
})